import React, { useState } from "react";
import "../../page_content.css";
import Accordion from "../../../components/reuseable_comp/accordion/Accordion";

const BoardOfBodies = () => {
  // Accordion open/close state
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // data for  accordion sections
  const boardsData = [
    {
      title: "Members of Governance Body",
      columns: ["Name", "Designation"],
      rows: [
        ["Dr. Chandrakant Pandav", "Member, Sponsoring-Body Nominee"],
        ["Prof. Rahul V. Karad", "Member, Sponsoring-Body Nominee"],
        ["Dr. Deepak Shikarpur", "Member, IT Expert, President Nominee"],
        ["Shri. Raj Kamble", "Member, State Government Nominee"],
        ["Shri. Vijayaraaj Bodhankar", "Member, State Government Nominee"],
        [
          "Padma Shri A S Kiran Kumar",
          "Member, Ex-Chairman-ISRO, President Nominee",
        ],
        [
          "Dr. M.K. Surappa",
          "Member, Vice-Chancellor, Anna-University, President Nominee",
        ],
        ["Shri. Shivsharan Mali", "Registrar, Member Secretary"],
      ],
    },
    {
      title: "Members of Academic Advisory Board",
      columns: ["Name", "Designation"],
      rows: [
        [
          "Capt. Pratik Khatu",
          "Chief Executive Officer, Orzel Maritime Pvt. Ltd.",
        ],
        [
          "Capt. Bharat Kapoor",
          "Technical Manager, Laurel Ship Management Pte. Ltd",
        ],
        [
          "Shri. Jogesh Sharma",
          "Head of MOLTC-Mitsui OSK Lines Maritime (India) Pvt. Ltd.",
        ],
        [
          "Prof. (Dr.) Mangesh T. Karad",
          "Executive President MIT ADT University, Pune",
        ],
        ["Capt. Prerit Misra", "Principal, MANET"],
        ["Capt. Deepak Munshi", "HOD, B.Sc. (Nautical Science), MANET"],
        ["Shri. Adwait Londhe", "HOD - Marine Engineering, MANET"],
        ["Shri. Rajiv Kashikar", "HOD- Training & Placements, MANET"],
      ],
    },
    {
      title: "Members of Mangement",
      columns: ["Struture", "Name"],
      rows: [
        ["Dr. Mangesh T. Karad", "Vice-Chancellor"],
        ["Prof. Rahul V. Karad", "Member, Sponsoring Body Nominee"],
        ["Mrs. Jyoti Dhakane", "Member, Sponsoring Body Nominee"],
        ["Mrs. Swati Chate", "Member, Sponsoring Body Nominee"],
        ["Dr. Suchitra U. Nagare", "Member, Sponsoring Body Nominee"],
        ["Prof. Sunita M. Karad", "Dean, Faculty of Management"],
        ["Dr. Kishore Ravande", "Dean, Faculty of Management and Innovation"],
        ["Dr. Vinayak Ghaisas", "Member, Sponsoring Body Nominee"],
        ["Prof. Dhimant Panchal", "Member, Sponsoring Body Nominee"],
        ["Prof. Krishnamurthy Thakur", "Member, Sponsoring Body Nominee"],
        ["Dr. Ramakant Kaplay", "Member, Sponsoring Body Nominee"],
        ["Shri. Shivsharan Mali", "Member, Sponsoring Body Nominee"],
      ],
    },
    {
      title: "BoS Committee Of B.Tech Marine Engineering",
      columns: ["Struture", "Name"],
      rows: [
        [
          "Head of the program / University Department in the relevant Subject",
          "Prof. Jaideep N Barve, HoD Marine Academics",
        ],
        [
          "Three teachers from amongst the full-time teachers of the University Department (Internal Members)",
          "1. Prof. Adwait Londhe",
        ],
        ["", "2. Prof. Shrikant Gunjal "],
        ["", "3. Prof. Sandip S. Chitre "],
        ["", "4. Dr. Vrushali Rampure "],
        ["", "5. Prof. Vijay D. Patil"],
        [
          "Co-opt one Professor from other University",
          "Prof. Swapnil Thamankar",
        ],
        [
          "Three experts with more than 15 years of experience in Industry / University/Research Organization / NGO etc. nominated by Vice Chancellor (External Members)",
          "1. Mr. Jeevan Gadre",
        ],
        ["", "2. Mr. Sannjeev Ogale"],
        ["", "3. Rohit Waman Parulekar"],
        [
          "A Ph. D. Scholar or Alumni (student) of the concerned subject may be invited as invitee member for discussion on framing or revision of syllabus of that subject or group of subjects for one year.",
          "Mr. Kale Aditya Dilip",
        ],
      ],
    },

    {
      title: "BoS Committee Of B.Sc (Nautical Science)",
      columns: ["Struture", "Name"],
      rows: [
        [
          "Head of the program / University Department in the relevant Subject",
          "Capt. Kashish Sharma, HOD - Nautical Science",
        ],
        [
          "Three teachers from amongst the full-time teachers of the University Department (Internal Members)",
          "1. Dr. Archana Bhange, Faculty",
        ],
        ["", "2. Capt. Sujay Gokhale, Faculty "],
        ["", "3. Prof. Tejaswini Yadav, Faculty "],
        ["", "Faculty 4. Mrs. Seema Kawade, Faculty "],
        ["", "5. Mr. Nilesh Kamthe, Faculty"],
        [
          "Co-opt one Professor from other University",
          "Capt. Deepak Tamras, Faculty (Samundra Institute of Maritime Studies)",
        ],
        [
          "Three experts with more than 15 years of experience in Industry / University / Research Organization / NGO etc. nominated by Vice Chancellor (External Members)",
          "1. Mr. Jeevan Gadre",
        ],
        ["", "2. Mr. Sannjeev Ogale"],
        ["", "3. Rohit Waman Parulekar"],
        [
          "A Ph. D. Scholar or Alumni (student) of the concerned subject may be invited as invitee member for discussion on framing or revision of syllabus of that subject or group of subjects for one year.",
          "Mr. Shantanu Wakchaure, Alumni",
        ],
      ],
    },
  ];

  return (
    <div>
      <h1  className="title">Board Of Bodies</h1>
      <hr />


      {boardsData.map((section, sectionIndex) => (
          <div key={sectionIndex} className="accordion-item">
            {/* Accordion Header */}
            <Accordion
              title={section.title}
              isActive={activeIndex === sectionIndex}
              onClick={() => handleToggle(sectionIndex)}
            />

          {activeIndex === sectionIndex && (
            <div className="accordion-content">
              <table className="page-content-table" style={{minWidth:"70%"}}>
                <thead>
                  <tr>
                    {section.columns.map((col, i) => (
                      <th key={i}>{col}</th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {(() => {
                    const mergedRows = [];
                    let lastRow = null;

                    section.rows.forEach((row) => {
                      if (row[0] === "") {
                        // If left cell empty → append to lastRow's right cell
                        if (lastRow) {
                          lastRow[1] += `<br/>${row[1]}`;
                        }
                      } else {
                        // Push previous row before starting a new one
                        if (lastRow) mergedRows.push(lastRow);
                        lastRow = [...row];
                      }
                    });

                    // Push the final row
                    if (lastRow) mergedRows.push(lastRow);

                    return mergedRows.map((row, i) => (
                      <tr key={i}>
                        <td dangerouslySetInnerHTML={{ __html: row[0] }}></td>
                        <td dangerouslySetInnerHTML={{ __html: row[1] }}></td>
                      </tr>
                    ));
                  })()}
                </tbody>
              </table>
            </div>
          )}
        </div>
        
      ))}
    </div>
  );
};

export default BoardOfBodies;
